class Spinner {
    constructor(button) {
        button.addEventListener('click', (e) => {
            e.preventDefault()
            const target = button.dataset.spinnerDecrease || button.dataset.spinnerIncrease
            const input = document.getElementById(target)
            const max = input.max ? parseInt(input.max) : Infinity
            const min = input.min ? parseInt(input.min) : -Infinity

            if (!target || !input) return;

            if (button.dataset.spinnerIncrease && input.value < max) {
                input.value++
            }
            if (button.dataset.spinnerDecrease && input.value > min) {
                input.value--
            }

            input.dispatchEvent(new Event('blur'))
            input.dispatchEvent(new Event('change', { bubbles: !0 }))
            input.dispatchEvent(new Event("input", { bubbles: !0 }))


        })
    }
}

export default Spinner


